module.exports = __webpack_public_path__ + "static/Joe Clarino-cd28d5f9879030217b01283e777988f8.png";